<template>
  <div class="home">
    <!-- 头部banner -->
    <banner></banner>
    <!-- 产品服务内容 -->
    <div class="content-product">
      <contentProduct></contentProduct>
    </div>
    <!-- 成功案例 -->
    <div class="succeed">
      <div class="succeed-word">
        <div class="succeed-title wow animate__fadeOut">成功案例</div>
        <div class="succeed-stu">Success Case Study</div>
      </div>
      <succeedCase></succeedCase>
    </div>
    <!-- 新闻资讯 -->
    <div class="news">
      <newsInformation></newsInformation>
    </div>
    <!-- logo -->
    <div class="logo">
      <div class="logo-main-img wow animate__slideInLeft">
        <img src="../../assets/LOGO.png" alt="" />
      </div>
      <div class="logo-vision wow animate__slideInRight">
           <div class="logo-content">
            <div class="logo-vision-one">
          用科技改善体育直播场景的用户体验
        </div>
        <div class="logo-vision-two">
          成为国内服务赛事等直播活动的第一技术平台服务商
        </div>
           </div>
      </div>
    </div>
    <!-- 底部 -->
    <webstat></webstat>
    <div class="fixed-button" v-if="showButton" @click="scrollToTop">
      <div class="fixed-top"><img src="../../assets/Vector.png" alt="" /></div>
    </div>
  </div>
</template>
<script>
import webstat from "./components/webstat/webstat.vue";
import banner from "./components/banner/banner.vue";
import contentProduct from "./components/content-product/content-product.vue";
import succeedCase from "./components/succeed-case/succeed-case.vue";
import newsInformation from "./components/news-information/news-information.vue";
import { WOW } from "wowjs";
export default {
  components: {
    webstat,
    banner,
    contentProduct,
    succeedCase,
    newsInformation
  },
  data() {
    return {
      showButton: false
    };
  },
  mounted() {
    //动画效果的初始化
    new WOW().init();
    //返回顶部监听
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  //返回顶部
  methods: {
    handleScroll() {
      this.showButton = window.pageYOffset > 580;
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  }
};
</script>
<style lang="less">
@import "./home.less";
</style>



// WEBPACK FOOTER //
// src/views/home/home.vue